export default "__VITE_ASSET__DPctxicc__"